<template>
    <ModalTheme :with-content="true" :theme="true" @close="closeModal" :fix-height="false">
        <template slot="main">
            <div class="text-center"><p>You are now in God mode. This mode allows you to fill quantities yourself instead of the markets.</p></div>
        </template>
    </ModalTheme>
</template>
<script>
import ModalTheme from "@/components/ui/ModalTheme";

export default {
    components: { ModalTheme },
    methods: {
        closeModal() {
            this.$emit("closed");
        }
    }
};
</script>



// WEBPACK FOOTER //
// GodModeModal.vue?ea8913d8